import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function getFormattedValue(
    value: number | string,
    delimiter = ",",
    commaDelimiter = ".",
  ): string {
    const arrValue = value.toString().split(commaDelimiter);

    arrValue[0] = arrValue[0].replace(/[^0-9]/g, "").replace(/^0+/g, "");

    const len = arrValue[0].length;
    for (let i = len - 3; i > 0; i -= 3) {
      arrValue[0] = `${arrValue[0].substring(
        0,
        i,
      )}${delimiter}${arrValue[0].substring(i)}`;
    }
    let localValue = arrValue[0];
    if (arrValue[1] !== undefined) {
      const decimal = arrValue[1].replace(/[^0-9]/g, "").replace(/^0+$/g, "");
      if (decimal) {
        localValue += commaDelimiter + decimal;
      }
    }
    return localValue;
  }

  return {
    getFormattedValue,
  };
}
